<template>
  <div class="form-item-country-wrapper">
    <div class="form-item-input-wrapper" :style="mobileClass">
      <!-- 头部输入框 -->
      <div
        class="search-input-wrapper"
        v-clickOutside="popoverOutsideClick"
        @click="toggleAreaList"
      >
        <input
          id="area-code"
          type="text"
          class="search-input"
          autocomplete="off"
          :placeholder="placeholder"
          v-model="searchText"
          data-search-type="search"
          @keydown.down="navigateOptions('next')"
          @keydown.up="navigateOptions('prev')"
          @keydown.enter="selectOption"
        />
        <img class="icon-search" src="~img/search-Icon.png" alt="search area code" />
      </div>

      <!-- 下拉展示部分 -->
      <!--      <transition name="fade">-->
      <div class="area-code-popover" v-show="showAreaCodePopover">
        <div class="area-code-list-wrapper">
          <ul class="area-code-list" role="listbox">
            <li
              role="option"
              v-for="(_, index) in showList"
              :class="['area-code-item-new', { active: hoverIndex === index }]"
              :data-index="index"
              :key="`${index}-${_.telabbr}`"
              @click="areaItemClick(_)"
              @mouseenter="hoverIndex = index"
            >
              <p class="area-name">{{ _.name }} ({{ _.iataCode }})</p>
              <p class="area-code">
                <span class="city">{{ _.cityName }}, </span>
                <span class="country">{{ _.countryName }}</span>
              </p>
            </li>
            <li role="option" class="search-no-results" v-show="showList.length === 0">
              {{ $t('search-box-no-found') }}
            </li>
          </ul>
        </div>
      </div>
      <!--      </transition>-->
    </div>
  </div>
</template>

<script>
  import { clickOutside } from '@/utils/directive.js';

  export default {
    props: {
      listData: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: '',
      },
      mobileClass: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        searchText: '',
        showAreaCodePopover: false,
        // 当前选中的下拉项的index值
        hoverIndex: -1,
      };
    },

    methods: {
      toggleAreaList() {
        this.showAreaCodePopover = true;
        // 聚焦input搜索框
        this.$el.querySelector('.search-input').focus();
      },

      areaItemClick(_) {
        this.showAreaCodePopover = false;
        this.$emit('searchClick', _);

        setTimeout(() => {
          // 在动画结束后再执行清空操作 <transition name="fade">
          this.searchText = '';
        }, 310);
      },

      popoverOutsideClick(e) {
        if (e.target.className.includes('search-input')) return;
        this.showAreaCodePopover && (this.showAreaCodePopover = false);
        this.hoverIndex = -1;
      },

      // 找到对应的按照机场名、国家名、城市名、三字码依次排序
      filterList(list, searchText) {
        let finalArr = [];
        const ncc = []; // 机场名 + 国家名 + 城市名
        const n = []; // 机场名
        const ct = []; // 国家名
        const c = []; // 城市名
        const i = []; // 三字码
        const key = searchText.toLowerCase();

        list.forEach(item => {
          if (
            item.name.toLowerCase().startsWith(key) &&
            item.countryName.toLowerCase().startsWith(key) &&
            item.cityName.toLowerCase().startsWith(key)
          ) {
            ncc.push(item);
          }
          if (item.name && item.name.toLowerCase().startsWith(key)) n.push(item);
          if (item.countryName && item.countryName.toLowerCase().startsWith(key)) ct.push(item);
          if (item.cityName && item.cityName.toLowerCase().startsWith(key)) c.push(item);
          if (item.iataCode && item.iataCode.toLowerCase().startsWith(key)) i.push(item);
        });

        // console.log('三合一', ncc, '机场名', n, '国家', ct, '城市', cn, '三字码', i);
        // [...[{1:'text',2:'abc'}], ...[{2:'aaa',3:'ddd'}]]
        finalArr = [...ncc, ...n, ...ct, ...c, ...i];

        return finalArr;
      },
      navigateOptions(direction) {
        if (this.showList.length === 0) return;
        if (direction === 'next') {
          this.hoverIndex = this.hoverIndex === this.showList.length - 1 ? 0 : this.hoverIndex + 1;
        } else {
          this.hoverIndex = this.hoverIndex <= 0 ? this.showList.length - 1 : this.hoverIndex - 1;
        }
        this.$nextTick(() => {
          // 当前选中的是否在可见范围,否则滚动下拉框,使其可见
          const el = this.$el.querySelector('.area-code-item-new.active');
          if (el) {
            const popover = this.$el.querySelector('.area-code-list-wrapper');
            // 处理极限情况,当前为第一个最后一个或者从最后一个时,需要滚动到底部或者顶部
            if (this.hoverIndex === 0 || this.hoverIndex === this.showList.length - 1) {
              popover.scrollTop = this.hoverIndex === 0 ? 0 : popover.scrollHeight;
              /* popover.scrollTo({
                top: this.hoverIndex === 0 ? 0 : popover.scrollHeight,
                behavior: 'instant',
              }); */
            } else {
              // 当前选中的是否在可见范围,否则滚动下拉框,使其可见
              const elTop = el.offsetTop;
              const elHeight = el.offsetHeight;
              const elBottom = elTop + elHeight;
              const popoverTop = popover.scrollTop;
              const popoverHeight = popover.offsetHeight;
              const popoverBottom = popoverTop + popoverHeight;
              // 获取area-code-popover元素的paddingTop
              const targetEl = this.$el.querySelector('.area-code-popover');
              const popoverPaddingTop = parseInt(
                window.getComputedStyle(targetEl, null).getPropertyValue('padding-top'),
              );
              if (elTop - popoverPaddingTop < popoverTop) {
                popover.scrollTop = elTop - popoverPaddingTop;
              } else if (elBottom > popoverBottom) {
                popover.scrollTop = elBottom - popoverHeight;
              }
            }
          }
        });
      },
      selectOption() {
        if (this.hoverIndex === -1) return;
        const _ = this.showList[this.hoverIndex];
        this.areaItemClick(_);
      },
    },

    computed: {
      // TODO: 如果数据量大，需要做优化调整，暂未处理后期有时间再处理
      list() {
        return this.listData;
      },

      showList() {
        let searchText = this.searchText || '';
        let data = this.list.filter(_ => _.name && _.cityName && _.countryName);
        if (searchText.length === 0) {
          return data;
        }

        // 选中exphone会有这个'+'
        searchText = searchText.replace('+', '\\+');

        // 找到对应的数据
        data = data.filter(_ => {
          const reg = new RegExp(searchText, 'gi');
          const name = reg.test(_.name);
          const cityName = reg.test(_.cityName);
          const countryName = reg.test(_.countryName);
          const iataCode = reg.test(_.iataCode);
          return name || cityName || countryName || iataCode;
        });

        // 对数据进行A-Z的排序
        const sortList = data.sort((a, b) => {
          return a.name.charAt(0).localeCompare(b.name.charAt(0));
        });

        // 根据特定条件搜索数据并精确置顶排序
        const accurateArr = this.filterList(sortList, searchText);
        // 合并排序后的数据
        const finalArr = [...accurateArr, ...sortList];

        // 除去重复的数据
        const newArray = [];
        finalArr.forEach(item => {
          const isinner = newArray.findIndex(ele => ele.id === item.id);
          if (isinner === -1) {
            newArray.push(item);
          }
        });
        return newArray;
      },
    },

    directives: { clickOutside },

    watch: {
      searchText(newVal) {
        if (!!newVal) {
          this.showAreaCodePopover = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index';
  @import './mobile.scss';
</style>
